import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'itemgroup',
  entityPlural: 'itemgroups',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV,
  state: {
    publishable: false
  }
});
